// extracted by mini-css-extract-plugin
export var modal = "_cc-0";